import { render, staticRenderFns } from "./proforma.vue?vue&type=template&id=3b86a732&scoped=true&"
import script from "./proforma.vue?vue&type=script&lang=js&"
export * from "./proforma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86a732",
  null
  
)

export default component.exports